import { useEffect } from 'react';
import { logEvent } from '../../lib/shared/event-logger';
import { EVENT_TYPES } from '../../lib/shared/event-types';

function useUserProperties(initialPrelander) {
    useEffect(() => {
        logEvent(EVENT_TYPES.USER_PROPERTIES, {
            'last_prelander': initialPrelander,
            initialPrelander,
            'user_agent': window.navigator.userAgent,
            'screen_height': window.visualViewport?.height || window.innerHeight,
            'screen_width': window.visualViewport?.width || window.innerWidth
        });
    }, []);
}

export {
    useUserProperties
};
